if (!customElements.get('card-dots')) {
  class CardDots extends HTMLElement {
    constructor() {
      super();

      this.dotsWrappers = this.querySelectorAll('[data-dots-wrapper]');
      this.dotsWrapperComputed = window.getComputedStyle(this.dotsWrappers[0]);
    }

    connectedCallback() {
      this.setDotSize();
      this.createObservers();
      this.updateDots();
    }

    createObservers() {
      this.resizeObserver = new ResizeObserver(this.updateDots.bind(this));
      this.resizeObserver.observe(this);
    }

    updateDots() {
      this.setDotSize();

      this.dotsWrappers.forEach((dotsWrapper) => {
        const startingDots = Array.from(dotsWrapper.children).slice(0, 6);

        const wrapperSize = Math.max(
          dotsWrapper.clientHeight,
          dotsWrapper.clientWidth,
        );
        const dotsCount = Math.floor(wrapperSize / this.dotSize);
        const currentDots = dotsWrapper.children.length;

        if (dotsCount > currentDots) {
          for (let i = currentDots; i < dotsCount; i++) {
            const clone = startingDots[i % startingDots.length].cloneNode(true);
            dotsWrapper.appendChild(clone);
          }
        } else if (dotsCount < currentDots) {
          for (let i = currentDots; i > dotsCount; i--) {
            dotsWrapper.removeChild(dotsWrapper.lastChild);
          }
        }
      });
    }

    setDotSize() {
      const dotWidth = this.dotsWrappers[0].children[0].offsetWidth;
      const dotsGap = +this.dotsWrapperComputed.columnGap.replace('px', '');

      this.dotSize = dotWidth + dotsGap;
    }
  }

  customElements.define('card-dots', CardDots);
}
